// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"65":"b9c73f12","903":"a897ec74","999":"a897ec74"}[chunkId] + ".chunk.css";
};